import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isTokenExpired } from '../utils/jwtUtils';
import { logout } from '../features/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_ADDRESS,
  cache: 'no-store',
  prepareHeaders: (headers, { getState }) => {
    headers.set('Cache-Control', 'no-cache');
    headers.set('Pragma', 'no-cache');
    const token = getState().auth.token;
    if (token) {
      // Check if token is expired before making the request
      if (isTokenExpired(token)) {
        // Token is expired, will be handled in baseQueryWithReauth
        return headers;
      }
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  // Check token expiration before making request
  const token = api.getState().auth.token;
  if (token && isTokenExpired(token)) {
    api.dispatch(logout());
    window.location.href = '/login';
    return { error: { status: 401, data: { error: 'Token expired' } } };
  }

  const result = await baseQuery(args, api, extraOptions);

  // Handle authentication errors
  if (result.error && (result.error.status === 401 || result.error.status === 403)) {
    api.dispatch(logout());
    window.location.href = '/login';
  }

  return result;
};
